import React, { useEffect, useState } from 'react';
import { Button, Card } from 'tabler-react';
import { useHistory } from 'react-router-dom';
import { useAPI } from '../../ApiCalls/useAPI';
import moment from 'moment';
import Select from 'react-select';
import RemoveLastDirectoryPartOf from '../goBackButton';
import './Events.scss';

const months = moment
    .monthsShort()
    .map((month) => ({ value: month, label: month }));

const START_YEAR = '2010';
const getYearOptions = () => {
    const years = [];
    for (let i = +START_YEAR; i <= +moment().year(); i++) {
        years.push({ value: i + '', label: i + '' });
    }
    return years;
};

const getDefaultMonth = () => {
    return {
        value: moment().format('MMM'),
        label: moment().format('MMM')
    };
};

const getDefaultYear = () => {
    return {
        value: moment().year(),
        label: moment().year()
    };
};

export default function Events() {
    const [events, setEvents] = useState([]);
    const [defaultMonth, setDefaultMonth] = useState(getDefaultMonth());
    const [defaultYear, setDefaultYear] = useState(getDefaultYear());
    const history = useHistory();
    const { getEvents } = useAPI();
    useEffect(() => {
        getEvents(defaultMonth.value, defaultYear.value)
            .then((data) => {
                // console.log(data);
                setEvents(data);
            })
            .catch((error) => console.error(error));
    }, [defaultMonth, defaultYear]);

    function clickHandler(event) {
        history.push({
            pathname: `/events/${event.eid}`,
            state: event
        });
    }

    function timeConverter(timestamp) {
        return moment.unix(timestamp).format('MMM Do YYYY');
    }

    function getHour(timestamp) {
        return moment.unix(timestamp).format('LT');
    }

    function renderEvents(events) {
        return events.map((event) => {
            return (
                <Card>
                    <Card.Header>
                        <Card.Title>
                            <div style={{ fontWeight: '600' }}>
                                {event.ename}
                            </div>
                        </Card.Title>
                        <Card.Options>
                            <Button
                                onClick={() => clickHandler(event)}
                                color="primary"
                                size="sm"
                            >
                                Details
                            </Button>
                        </Card.Options>
                    </Card.Header>
                    <Card.Body>
                        <div>
                            <div
                                style={{ margin: '5px' }}
                                className="eventsdate"
                            >
                                <i className="fe fe-calendar" />
                                <span className="ml-2">
                                    {timeConverter(event.eventdate)}
                                </span>
                            </div>
                            <div style={{ display: 'flex' }}>
                                <div
                                    style={{ margin: '5px' }}
                                    className="eventsplace"
                                >
                                    <i className="fe fe-map-pin"></i>
                                    <span className="ml-2">
                                        {event.eventPlace}
                                    </span>
                                </div>
                                <div
                                    style={{ margin: '5px' }}
                                    className="eventstime"
                                >
                                    <i className="fe fe-clock"></i>
                                    <span className="ml-2">
                                        {getHour(event.eventdate)}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </Card.Body>
                </Card>
            );
        });
    }

    return (
        <div className="container">
            <div className="m-2" style={{ fontSize: '20px', display: 'flex' }}>
                <div className="mr-4">
                    <a
                        href={RemoveLastDirectoryPartOf(window.location.href)}
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="fe fe-arrow-left" />
                    </a>
                </div>
                <div>Events</div>
            </div>
            <div className="d-flex justify-content-center mt-2 mb-2">
                <Select
                    defaultValue={defaultMonth}
                    onChange={setDefaultMonth}
                    options={months}
                    isSearchable={false}
                />
                <Select
                    defaultValue={defaultYear}
                    onChange={setDefaultYear}
                    options={getYearOptions()}
                    isSearchable={false}
                />
            </div>
            {events.length ? (
                renderEvents(events)
            ) : (
                <h1 class="mt-4 text-center">NO EVENTS FOUND</h1>
            )}
        </div>
    );
}
